import {
  Button,
  Form,
  Image,
  Input,
  Modal,
  Select,
  Spin,
  Table,
  Upload,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { BsFillCloudUploadFill } from "react-icons/bs";
import { CiWarning } from "react-icons/ci";
import adminServices from "../../services/httpServices";
import TextArea from "antd/es/input/TextArea";
import { FaPersonChalkboard } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import { UploadOutlined, PlusOutlined } from "@ant-design/icons";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { FaEdit } from "react-icons/fa";
import EditBoard from "../../components/editBoard";
import { currentDateTime } from "../../helpers/helpers";
import NotificationService from "../../NotificationService";

const Board = () => {
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const [tableData, setTableData] = useState([]);
  const [isloading, setIsloading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenForm, setIsModalOpenForm] = useState(false);
  const [deleteID, setdeleteID] = useState(undefined);
  const [selectCate, setSelectCate] = useState([]);
  const [postCate, setpostCate] = useState([]);

  // ── Image state ────────────────────────────────────────────────────────────
  const [imagePath, setImagePath] = useState("");
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [uploadedimage, setUploadedImage] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [imageUploading, setImageUploading] = useState(false);

  const { pathname } = useLocation();
  const [postData, setPostData] = useState([]);
  const [EditId, setEditId] = useState(undefined);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const initialValues = {
    id: 0,
    title: "",
    name: "",
    description: "",
    imgUrl: "",
    dateCreated: currentDateTime,
    videoUrl: "",
  };

  // ── Table columns ──────────────────────────────────────────────────────────
  const columns = [
    {
      title: "S/N",
      dataIndex: "id",
      key: "id",
      width: 60,
      render: (_, __, idx) => (
        <span className="font-medium text-gray-500">{idx + 1}</span>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 140,
      render: (text) => (
        <span className="font-semibold text-gray-800 capitalize">{text}</span>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 180,
      render: (text) => (
        <span className="text-gray-700 capitalize">{text}</span>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => (
        <p className="text-gray-600 text-sm line-clamp-3 max-w-xs">{text}</p>
      ),
    },
    {
      title: "Category",
      dataIndex: "teamType",
      key: "teamType",
      width: 120,
      render: (text) => (
        <span className="px-2 py-1 bg-amber-100 text-amber-800 rounded-full text-xs font-medium">
          {text}
        </span>
      ),
    },
    {
      title: "Staff Image",
      dataIndex: "imgUrl",
      width: 120,
      key: "imgUrl",
      render: (url) =>
        url ? (
          <div
            style={{
              width: 80,
              height: 80,
              borderRadius: 12,
              overflow: "hidden",
              border: "1px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <img
              src={url}
              alt="staff"
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
        ) : (
          <div
            style={{
              width: 80,
              height: 80,
              borderRadius: 12,
              background: "#f3f4f6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px dashed #d1d5db",
            }}
          >
            <span style={{ color: "#9ca3af", fontSize: 11 }}>No image</span>
          </div>
        ),
    },
    {
      title: "Actions",
      width: 100,
      render: (record) => (
        <div className="flex items-center gap-3">
          <button
            onClick={() => actionDeleteModalOpen(record?.id)}
            className="p-2 rounded-lg bg-red-50 text-red-500 hover:bg-red-100 transition-colors"
            title="Delete"
          >
            <RiDeleteBin6Fill className="text-base" />
          </button>
          <button
            onClick={() => {
              setIsEditModalOpen(true);
              setEditId(record?.id);
            }}
            className="p-2 rounded-lg bg-blue-50 text-blue-500 hover:bg-blue-100 transition-colors"
            title="Edit"
          >
            <FaEdit className="text-base" />
          </button>
        </div>
      ),
    },
  ];

  const columns2 = [
    {
      title: "S/N",
      dataIndex: "id",
      key: "id",
      width: 60,
      render: (_, __, idx) => (
        <span className="font-medium text-gray-500">{idx + 1}</span>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 150,
      render: (text) => (
        <span className="font-semibold text-gray-800 capitalize">{text}</span>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => (
        <p className="text-gray-600 text-sm line-clamp-3 max-w-xs">{text}</p>
      ),
    },
    {
      title: "Category",
      dataIndex: "categoryName",
      key: "categoryName",
      width: 130,
      render: (text) => (
        <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium">
          {text}
        </span>
      ),
    },
    {
      title: "Image",
      dataIndex: "imgUrl",
      width: 120,
      key: "imgUrl",
      render: (url) =>
        url ? (
          <div
            style={{
              width: 80,
              height: 80,
              borderRadius: 12,
              overflow: "hidden",
              border: "1px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <img
              src={url}
              alt="post"
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
        ) : null,
    },
    {
      title: "Video",
      width: 160,
      render: (record) =>
        record?.vidoeUrl ? (
          <div className="rounded-xl overflow-hidden border border-gray-200">
            <iframe
              width="140"
              height="100"
              src={record.vidoeUrl}
              title="video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        ) : null,
    },
    {
      title: "Actions",
      width: 90,
      render: (record) => (
        <button
          onClick={() => actionDeleteModalOpen(record?.id)}
          className="px-3 py-1.5 bg-red-500 text-white text-xs font-semibold rounded-lg hover:bg-red-600 transition-colors"
        >
          Delete
        </button>
      ),
    },
  ];

  // ── Data fetchers ──────────────────────────────────────────────────────────
  const fetchPost = async () => {
    setIsloading(true);
    try {
      const res = await adminServices.getAllPostData();
      const mapped = res?.data
        ?.filter((v) => v.isactive === true)
        .map((v, i) => ({ ...v, key: i }));
      setPostData(mapped);
    } catch (error) {
      NotificationService.show(error.message, "error");
    } finally {
      setIsloading(false);
    }
  };

  const fetchCategorys = async () => {
    try {
      const res = await adminServices.getStaffCategory();
      setSelectCate(res.data);
    } catch (error) {
      NotificationService.show(error.message, "error");
    }
  };

  const fetchPostCate = async () => {
    try {
      const res = await adminServices.getAllPostType();
      setpostCate(res.data);
    } catch (error) {
      NotificationService.show(error.message, "error");
    }
  };

  const fetchBoards = async () => {
    setIsloading(true);
    try {
      const response = await adminServices.getAllBoard();
      const mapped = response?.data
        ?.filter((v) => v.isActive === true)
        .map((v, i) => ({ ...v, key: i }));
      setTableData(mapped);
    } catch (error) {
      NotificationService.show(error.message, "error");
      setTableData([]);
    } finally {
      setIsloading(false);
    }
  };

  // ── Image upload ───────────────────────────────────────────────────────────
  const imageUpload = async (file) => {
    if (!file) return "";
    setImageUploading(true);
    try {
      const data = new FormData();
      data.append("File", file);
      const res = await adminServices.fileUpload(data);

      const path = res?.data?.path || res?.data?.data?.path || res?.path || "";

      if (!path) {
        message.error("Image uploaded but no path returned. Check API response.");
        return "";
      }

      // Only update imagePath (used for API submission), NOT imagePreviewUrl
      setImagePath(path);
      message.success("Image uploaded successfully");
      return path;
    } catch (error) {
      message.error("Image upload failed: " + (error.message || "Unknown error"));
      return "";
    } finally {
      setImageUploading(false);
    }
  };

  const handleImageChange = async (info) => {
    const file = info.file.originFileObj || info.file;
    if (!file) return;

    // Show local preview immediately and keep it — don't overwrite with Cloudinary URL
    const reader = new FileReader();
    reader.onload = (e) => setImagePreviewUrl(e.target.result);
    reader.readAsDataURL(file);

    setUploadedImage(file);
    await imageUpload(file);
  };

  const dummyRequest = ({ onSuccess }) => setTimeout(() => onSuccess("ok"), 0);

  // ── Handlers ───────────────────────────────────────────────────────────────
  const actionDeleteModalOpen = (id) => {
    setIsModalOpen(true);
    setdeleteID(id);
  };

  const OnCancelHandler = () => {
    setIsModalOpenForm(false);
    setIsModalOpen(false);
    setIsloading(false);
    setFileList([]);
    setdeleteID(undefined);
    setUploadedImage(null);
    setImagePath("");
    setImagePreviewUrl("");
    form.setFieldsValue(initialValues);
  };

  const actionDeleteHandler = async () => {
    try {
      pathname === "/Post" || pathname === "/business-news"
        ? await adminServices.deletePost(deleteID)
        : await adminServices.mgtDelete(deleteID);
      setIsModalOpen(false);
      NotificationService.show("Deleted successfully", "success");
    } catch (error) {
      NotificationService.show(error.message, "error");
    }
  };

  const createSliderHandler = async (data) => {
    if (!imagePath) {
      message.warning("Please upload an image before submitting.");
      return;
    }
    delete values?.photo55;
    setIsloading(true);
    try {
      const res = await adminServices.createNewBoardMember({
        ...data,
        imgUrl: imagePath,
        dateCreated: currentDateTime,
      });
      if (res.status === 200) {
        message.success("Member created successfully");
        OnCancelHandler();
      }
    } catch (error) {
      NotificationService.show(error.message, "error");
    } finally {
      setIsloading(false);
    }
  };

  const createPostHandler = async (data) => {
    if (!imagePath) {
      message.warning("Please upload an image before submitting.");
      return;
    }
    setIsloading(true);
    try {
      const res = await adminServices.Post({
        ...data,
        id: 0,
        imgUrl: imagePath,
        isActive: true,
        dateCreated: currentDateTime,
      });
      if (res.status === 200) {
        message.success("Post created successfully");
        OnCancelHandler();
      }
    } catch (error) {
      NotificationService.show(error.message, "error");
    } finally {
      setIsloading(false);
    }
  };

  useEffect(() => {
    fetchBoards();
    fetchCategorys();
    fetchPost();
    fetchPostCate();
  }, [isModalOpenForm, isEditModalOpen, isModalOpen, pathname]);

  const pageTitle =
    pathname === "/boards"
      ? "Board of Directors & Management Staff"
      : pathname === "/business-news"
      ? "Business News"
      : "Homepage Post Data";

  const isPost = pathname === "/Post" || pathname === "/business-news";

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* ── Header ── */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#001529] flex items-center justify-center">
            <FaPersonChalkboard className="text-white text-lg" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900">{pageTitle}</h1>
            <p className="text-sm text-gray-500">
              {(isPost ? postData : tableData)?.length || 0} records
            </p>
          </div>
        </div>
        <button
          onClick={() => setIsModalOpenForm(true)}
          className="flex items-center gap-2 px-5 py-2.5 bg-[#001529] text-white font-semibold rounded-xl hover:bg-[#002a50] transition-colors shadow-md"
        >
          <BsFillCloudUploadFill className="text-lg" />
          <span>Upload New</span>
        </button>
      </div>

      {/* ── Table ── */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <Spin
          spinning={isloading}
          size="large"
          tip="Loading data..."
          className="text-[#9b7c27] font-bold"
        >
          <Table
            dataSource={isPost ? postData : tableData}
            columns={isPost ? columns2 : columns}
            className="heritage-table"
            scroll={{ x: 800 }}
            pagination={{
              pageSize: 10,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} records`,
              className: "px-4 py-3",
            }}
            rowClassName="hover:bg-amber-50 transition-colors"
          />
        </Spin>
      </div>

      {/* ── Delete Confirmation Modal ── */}
      <Modal
        open={isModalOpen}
        centered
        onCancel={OnCancelHandler}
        footer={null}
        width={400}
      >
        <div className="flex flex-col items-center text-center p-6 gap-4">
          <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
            <CiWarning className="text-4xl text-red-500" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">
              This action is irreversible
            </h3>
            <p className="text-gray-500 text-sm mt-1">
              Are you sure you want to delete this record?
            </p>
          </div>
          <div className="flex gap-3 w-full mt-2">
            <button
              onClick={OnCancelHandler}
              className="flex-1 py-2.5 border border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={actionDeleteHandler}
              className="flex-1 py-2.5 bg-red-500 text-white font-semibold rounded-xl hover:bg-red-600 transition-colors"
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>

      {/* ── Create Form Modal ── */}
      <Modal
        open={isModalOpenForm}
        centered
        onCancel={() => setIsModalOpenForm(false)}
        footer={null}
        width={520}
        title={
          <div className="flex items-center gap-2 pb-2">
            <PlusOutlined className="text-[#001529]" />
            <span className="font-bold text-gray-900">
              {isPost ? "Create New Post" : "Add New Member"}
            </span>
          </div>
        }
      >
        <Spin
          spinning={isloading || imageUploading}
          tip={imageUploading ? "Uploading image..." : "Saving..."}
        >
          <Form
            form={form}
            initialValues={initialValues}
            layout="vertical"
            className="pt-2"
            onFinish={isPost ? createPostHandler : createSliderHandler}
          >
            {/* Image Upload */}
            <Form.Item
              label={
                <span className="font-semibold text-gray-700">
                  Upload Image <span className="text-red-500">*</span>
                </span>
              }
              name="photo55"
            >
              <div className="flex items-start gap-4">
                {/* Preview */}
                <div
                  style={{
                    width: 96,
                    height: 96,
                    borderRadius: 12,
                    border: "2px dashed #d1d5db",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#f9fafb",
                    flexShrink: 0,
                  }}
                >
                  {imagePreviewUrl ? (
                    <img
                      src={imagePreviewUrl}
                      alt="preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                  ) : (
                    <div style={{ textAlign: "center", padding: 8 }}>
                      <div style={{ fontSize: 24, color: "#d1d5db", marginBottom: 4 }}>📷</div>
                      <span style={{ fontSize: 11, color: "#9ca3af" }}>Preview</span>
                    </div>
                  )}
                </div>

                <div className="flex-1">
                  <Upload
                    onChange={handleImageChange}
                    customRequest={dummyRequest}
                    maxCount={1}
                    accept=".png,.jpg,.jpeg,.webp"
                    showUploadList={false}
                    fileList={fileList}
                  >
                    <button
                      type="button"
                      className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-xl text-sm text-gray-700 hover:border-[#001529] hover:text-[#001529] transition-colors bg-white"
                    >
                      <UploadOutlined />
                      {imageUploading ? "Uploading..." : "Choose Image"}
                    </button>
                  </Upload>
                  <p className="text-xs text-gray-400 mt-2">PNG, JPG, WEBP · Max 5MB</p>
                  {imagePath && (
                    <p className="text-xs text-green-600 mt-1 flex items-center gap-1">
                      ✅ Image uploaded successfully
                    </p>
                  )}
                </div>
              </div>
            </Form.Item>

            <Form.Item
              name="title"
              label={
                <span className="font-semibold text-gray-700">Title</span>
              }
              rules={[{ required: true, message: "Title is required" }]}
            >
              <Input placeholder="Enter title" className="rounded-xl h-10" />
            </Form.Item>

            {!isPost && (
              <Form.Item
                name="name"
                label={
                  <span className="font-semibold text-gray-700">Name</span>
                }
                rules={[{ required: true, message: "Name is required" }]}
              >
                <Input
                  placeholder="Enter full name"
                  className="rounded-xl h-10"
                />
              </Form.Item>
            )}

            <Form.Item
              name="description"
              label={
                <span className="font-semibold text-gray-700">Description</span>
              }
              rules={[{ required: true, message: "Description is required" }]}
            >
              <TextArea
                placeholder="Enter description"
                rows={4}
                className="rounded-xl"
              />
            </Form.Item>

            <Form.Item
              name="categoryId"
              label={
                <span className="font-semibold text-gray-700">Category</span>
              }
              rules={[{ required: true, message: "Please select a category" }]}
            >
              <Select
                showSearch
                allowClear
                optionFilterProp="children"
                placeholder="Select category"
                className="rounded-xl"
                size="large"
              >
                {(isPost ? postCate : selectCate).map(({ id, name }, i) => (
                  <Select.Option value={id} key={i}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {isPost && (
              <Form.Item
                name="videoUrl"
                label={
                  <span className="font-semibold text-gray-700">Video URL</span>
                }
                rules={[{ required: true, message: "Video URL is required" }]}
              >
                <Input
                  placeholder="https://youtube.com/..."
                  className="rounded-xl h-10"
                />
              </Form.Item>
            )}

            <div className="flex gap-3 pt-2">
              <button
                type="button"
                onClick={() => setIsModalOpenForm(false)}
                className="flex-1 py-2.5 border border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={imageUploading}
                className="flex-1 py-2.5 bg-[#001529] text-white font-semibold rounded-xl hover:bg-[#002a50] transition-colors disabled:opacity-60"
              >
                {isPost ? "Create Post" : "Add Member"}
              </button>
            </div>
          </Form>
        </Spin>
      </Modal>

      {/* ── Edit Modal ── */}
      <Modal
        open={isEditModalOpen}
        centered
        onCancel={() => {
          setIsEditModalOpen(false);
          setEditId(undefined);
        }}
        footer={null}
        width={520}
        title={
          <div className="flex items-center gap-2 pb-2">
            <FaEdit className="text-[#001529]" />
            <span className="font-bold text-gray-900">Edit Member</span>
          </div>
        }
      >
        <EditBoard id={EditId} setIsEditModalOpen={setIsEditModalOpen} />
      </Modal>
    </div>
  );
};

export default Board;